/* Big Gun V3 collection and search pages. Spec:
   Strategy/2026-10/collection-v3/Spec-2026-10-03.md
   Built ON the Garage engine (bge-garage.js: BGE.garageFilter, BGE.fitFeed) and the
   theme's own AJAX filter (theme.js: Shopify.queryParams + History.pushState with
   ?constraint=, which swaps .sidebar_content and #Collection). Nothing here replaces
   either; it reads their state and drives their controls.
   1. sticky offset  2. fit bar  3. applied row + machine chips  4. filter sheet
   (batch apply, counts)  5. model groups  6. ladder  7. load more  8. search row
   9. promoted filter row  10. toolbar count + sort label */
(function () {
  'use strict';
  var root = document.querySelector('[data-bgv3]');
  if (!root) return;
  var SCOPE = root.getAttribute('data-scope');
  var DESK = window.matchMedia('(min-width: 1025px)');
  var html = document.documentElement;

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function plural(n, w) { return n === 1 ? w : w + 's'; }
  // Write only on change: an unchanged innerHTML or textContent write still queues a mutation
  // record, and the .bgv3-plp observer turns every record into another refresh (CR-17).
  function setHTML(el, s) { if (el && el.__bgv3html !== s) { el.innerHTML = s; el.__bgv3html = s; } }
  function setText(el, s) { if (el && el.textContent !== s) el.textContent = s; }
  function handleize(s) { return String(s || '').toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function B() { return window.BGE || {}; }
  function track(name, p) { try { if (typeof window.gtag === 'function') window.gtag('event', name, p || {}); } catch (e) { /* ignore */ } }
  var ICON = {
    x: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    check: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>',
    chev: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6"/></svg>',
    garage: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 9l9-6 9 6v11H3z"/><path d="M7 21v-9h10v9"/><path d="M7 16h10"/></svg>'
  };

  // ---- 1. Sticky offset: the toolbar and the desktop sidebar sit under the sticky header ----
  function stickyTop() {
    var h = 0;
    qsa('.header-sticky.is-sticky, .bge-garage-bar').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.top <= 1 && r.bottom > h) h = r.bottom;
    });
    root.style.setProperty('--bgv3-sticky-top', Math.max(0, Math.round(h)) + 'px');
  }
  var stickyQueued = false;
  window.addEventListener('scroll', function () {
    if (stickyQueued) return; stickyQueued = true;
    requestAnimationFrame(function () { stickyQueued = false; stickyTop(); });
  }, { passive: true });
  window.addEventListener('resize', stickyTop);

  // ---- Garage helpers ------------------------------------------------------
  function garage() { var b = B(); return b.Garage ? b.Garage.list() : []; }
  // Machines saved before a model was required: shown as "Pick model", never filtered on.
  function legacy() { var b = B(); return b.Garage && b.Garage.needsModel ? b.Garage.needsModel() : []; }
  function pickBtn(v, cls, label) { var b = B(); return b.pickModelHtml ? b.pickModelHtml(v, cls, label) : ''; }
  function gfState() { var b = B(); return b.garageFilter ? b.garageFilter.state : null; }
  function gfSelectedIds() {
    return qsa('[data-bge-gf-block] [data-bge-gf-v]:checked').map(function (i) { return i.value; });
  }
  function vName(v) { var b = B(); return b.formatVehicle ? b.formatVehicle(v) : [v.year, v.make, v.model].filter(Boolean).join(' '); }
  function vShort(v) { return [v.year, v.model || v.make].filter(Boolean).join(' '); }
  function totalInView() {
    var c = qs('#Collection');
    return c ? parseInt(c.getAttribute('data-bgv3-total'), 10) || 0 : 0;
  }
  // The index of a view (current or pending constraint), shared with the engine's cache.
  function viewKey(constraint) {
    var u = new URL(window.location.href), p = new URLSearchParams();
    var c = constraint === undefined ? u.searchParams.get('constraint') : constraint;
    if (c) p.set('constraint', c);
    var sort = u.searchParams.get('sort_by'); if (sort) p.set('sort_by', sort);
    var q = p.toString().replace(/%2B/g, '+');
    return u.pathname + (q ? '?' + q : '');
  }
  function index(constraint) {
    var b = B();
    if (!b.fitFeed || SCOPE === 'search') return Promise.reject(new Error('no feed'));
    return b.fitFeed.index(viewKey(constraint));
  }
  function rowTagHandles(row) {
    if (!row.__h) row.__h = String(row[2] || '').split('|').map(function (t) { return handleize(t.trim()); });
    return row.__h;
  }
  // Rows the grid would show with the current Garage selection (fits + universal), or all rows.
  function garageRows(rows) {
    var b = B(), ids = gfSelectedIds(), st = gfState();
    if (!ids.length || !b.fitFeed || !b.parseTags || (st && st.result && !st.result.fits.length)) return rows;
    var vs = garage().filter(function (v) { return ids.indexOf(v.id) >= 0; });
    if (!vs.length) return rows;
    return rows.filter(function (r) {
      if (!r.__p) r.__p = b.parseTags(r[2] || '');
      var s = b.fitFeed.best(r.__p, vs, r[3]).state;
      return s === 'fits' || s === 'universal';
    });
  }

  // ---- 2. Fit bar (one line) -------------------------------------------------
  var fit = qs('[data-bgv3-fit]');
  function setFit(state, text, act) {
    if (!fit) return;
    fit.setAttribute('data-state', state);
    fit.setAttribute('data-bgv3-set', ''); // script owns the line now (FL1-53)
    var t = qs('[data-bgv3-fit-text]', fit), a = qs('[data-bgv3-fit-act]', fit);
    if (t) t.innerHTML = text;
    if (a) a.innerHTML = act || '';
  }
  var addBtn = '<button type="button" class="bgv2-btn bgv2-btn--secondary bgv2-btn--sm" data-bge-action="open-drawer">Add a machine</button>';
  // Is every part in this view universal (packing kits, decals)? The engine's own rule, read from the server
  // cards when the view fits on one page, else confirmed from the index only when page one is all universal,
  // so riders with no machine (or a model-less one) still get the universal message (FL1-51).
  var uniView = null, pipeView = false;
  function universalRow(tags, type) {
    var b = B();
    if (!b.parseTags || !b.checkFitment) return null;
    return b.checkFitment(b.parseTags(tags || ''), { year: '2020', make: '-', model: '-' }, type || '') === 'universal';
  }
  // A part that fits by pipe, not by machine: tagged Replacement Parts or typed Exhaust Parts (packing kits,
  // end caps). Gear (T-shirts, hats, the gift card) is universal too but does not fit a muffler (FL2-01).
  function byPipeRow(tags, type) {
    return /(^|\|)\s*replacement parts\s*(\||$)/i.test(tags || '') || String(type || '').trim().toLowerCase() === 'exhaust parts';
  }
  // The universal line for this view: "fit by muffler" only when every part is a by-pipe part.
  function universalLine() {
    var s = (window.BGV2 && window.BGV2.strings) || {};
    return esc(pipeView ? (s.fitByPipe || 'These parts are not machine specific. They fit by muffler, not by machine.') : (s.fitUniversal || 'These parts are not machine specific.'));
  }
  function checkUniversalView() {
    if (uniView !== null || SCOPE === 'search') return;
    var cards = qsa('#Collection [data-bge-tags]');
    if (!cards.length) { uniView = false; return; }
    var flags = cards.map(function (c) { return universalRow(c.getAttribute('data-bge-tags'), c.getAttribute('data-bge-type')); });
    if (flags.indexOf(null) >= 0) return; // engine not ready: ask again on the next render
    if (flags.indexOf(false) >= 0) { uniView = false; return; }
    var pipe = cards.every(function (c) { return byPipeRow(c.getAttribute('data-bge-tags'), c.getAttribute('data-bge-type')); });
    if (totalInView() <= cards.length) { uniView = true; pipeView = pipe; return; }
    uniView = false;
    index().then(function (rows) {
      if (rows.length && rows.every(function (r) { return universalRow(r[2], r[3]) === true; })) {
        uniView = true;
        pipeView = rows.every(function (r) { return byPipeRow(r[2], r[3]); });
        renderFit();
      }
    }, function () {});
  }
  function renderFit() {
    if (!fit || SCOPE === 'search') return;
    var vs = garage();
    if (!vs.length) {
      checkUniversalView();
      if (uniView) { setFit('universal', universalLine(), ''); return; }
      // A model-less machine of another make on a one-make page gets the none-fit line, not the prompt (FL5-09).
      var olds = legacy(), old = B().legacyForPage ? B().legacyForPage(olds) : olds[0];
      if (old) setFit('none', 'Your ' + esc(vName(old)) + ' needs a model before we can show the parts that fit', pickBtn(old, 'bgv2-btn bgv2-btn--secondary bgv2-btn--sm', 'Pick your model'));
      else if (olds.length && SCOPE === 'model') setFit('zero', 'None of these fit your ' + esc(vName(olds[0])) + '.', addBtn);
      else if (olds.length) setFit('zero', 'None of these fit your ' + esc(vName(olds[0])) + '. Showing all ' + totalInView() + '.',
        B().browseUrl ? '<a class="bgv2-textlink" href="' + esc(B().browseUrl(olds[0])) + '">Shop ' + esc(olds[0].make) + ' parts</a>' : '');
      else setFit('none', 'Add your machine to see only the parts that fit', addBtn);
      return;
    }
    var st = gfState(), res = st && st.result, ids = gfSelectedIds();
    var banner = qs('[data-bge-gf-banner]');
    var mode = banner && !banner.hidden ? banner.getAttribute('data-mode') : '';
    var total = res ? res.total : totalInView();
    if (SCOPE === 'model' && !ids.length) {
      // Model pages do not filter by default: say how many fit the saved machine(s) here.
      if (!res) { setFit('pending', 'Checking your machines against these parts', ''); return; }
      // The count is against every saved machine, the set the cards are badged with here (FL1-18): a part that fits
      // any of them counts once (res.anyFit), so the bar never says 14 of 22 over 22 "Fits your" cards (FL2-20).
      var mine = vs.filter(function (v) { return (res.perVehicle[v.id] || 0) > 0; });
      var nAny = res.anyFit || 0;
      if (mine.length && nAny > 0) {
        setFit('fit', 'Your ' + esc(mine.length === 1 ? vName(mine[0]) : mine.length + ' machines') + ': ' + nAny + ' of ' + total + ' ' + plural(total, 'part') + ' fit' +
          (res.wrongYear ? '<span class="bgv3-fit__note">' + res.wrongYear + ' more fit other years. They are marked.</span>' : ''),
          '<button type="button" class="bgv2-textlink" data-bge-action="open-drawer">Change</button>');
      } else if (res.universal && res.universal.length && !res.fits.length) {
        setFit('universal', esc(((window.BGV2 && window.BGV2.strings) || {}).fitUniversal || 'These parts are not machine specific.'), '');
      } else {
        setFit('zero', 'None of these fit your ' + esc(vs.length === 1 ? vName(vs[0]) : 'saved machines') + '.', addBtn);
      }
      return;
    }
    if (mode === 'loading' || (!res && ids.length)) { setFit('pending', 'Finding parts that fit your ' + esc(ids.length === 1 && vs.length ? vName(vs.filter(function (v) { return v.id === ids[0]; })[0] || vs[0]) : 'machines'), ''); return; }
    if (!res) { setFit('none', 'Add your machine to see only the parts that fit', addBtn); return; }
    var sel = vs.filter(function (v) { return ids.indexOf(v.id) >= 0; });
    if (!ids.length) {
      setFit('all', 'Showing all ' + total + ' ' + plural(total, 'part'),
        res.anyFit ? '<button type="button" class="bgv2-textlink" data-bge-action="gf-fit">Show parts for my ' + esc(vs.length === 1 ? (vs[0].model || vs[0].make) : 'machines') + '</button>' : '');
      return;
    }
    if (!res.fits.length && res.universal && res.universal.length && res.universal.length === res.total) {
      // All-universal view (packing kits, decals): nothing to narrow. Never "none fit". The muffler wording only
      // when every part fits by pipe (FL2-01).
      checkUniversalView();
      setFit('universal', universalLine(), '');
      return;
    }
    if (!res.fits.length) {
      var who = sel.length === 1 ? vName(sel[0]) : sel.length + ' machines';
      // The Shop link names the bar's machine, else the active one (FL3-22): sel is in Garage order, so sel[0] was the
      // first saved machine (Raptor) while the RZR was active.
      var act = B().Garage && B().Garage.active ? B().Garage.active() : null;
      var one = sel.filter(function (v) { return act && v.id === act.id; })[0] || sel[0];
      var link = one && B().browseUrl ? '<a class="bgv2-textlink" href="' + esc(B().modelUrl && B().modelUrl(one) || B().browseUrl(one)) + '">Shop ' + esc(one.model || one.make) + ' parts</a>' : '';
      setFit('zero', 'None of these fit your ' + esc(who) + '. Showing all ' + total + '.', link);
      return;
    }
    var withFits = sel.filter(function (v) { return res.perVehicle[v.id] > 0; });
    var n = res.fits.length;
    var notes = [];
    var none = sel.filter(function (v) { return !res.perVehicle[v.id]; });
    if (none.length) notes.push('<span>None fit your ' + esc(none.map(vName).join(' or ')) + ' here.</span>');
    // The universal group further down, in the banner's words (FL2-19, call 67). The one note phones keep (N-A22).
    if (res.universal && res.universal.length) notes.push('<span class="bgv3-fit__uni">Plus ' + res.universal.length + ' universal ' + plural(res.universal.length, 'part') + '.</span>');
    if (res.wrongYear) notes.push('<span>' + res.wrongYear + ' more fit other years.</span>');
    setFit('fit', n + ' ' + plural(n, 'part') + ' fit your ' + esc(withFits.length === 1 ? vName(withFits[0]) : withFits.length + ' machines') +
      (notes.length ? '<span class="bgv3-fit__note">' + notes.join(' ') + '</span>' : ''),
      '<button type="button" class="bgv2-textlink bgv3-fit__all" data-bge-action="gf-show-all">Show all ' + total + '</button>');
  }

  // ---- 3. Applied row: machines first (one tap selects only that one), then tag pills ----
  function renderMachines() {
    var row = qs('[data-bgv3-applied]');
    if (!row) return;
    var vs = garage();
    var block = qs('[data-bge-gf-block]');
    var hasTags = !!qs('[data-bgv3-remove-tag]', row);
    var st = gfState(), res = st && st.result;
    // All-universal views (packing kits): every part fits every machine, so per-machine "0" chips would mislead.
    var allUniversal = res && !res.fits.length && res.universal && res.universal.length === res.total;
    var off = !vs.length || !block || SCOPE === 'search' || allUniversal;
    var ids = gfSelectedIds();
    var old = off ? [] : legacy();
    // Rebuild the chips only when what they show changes, so a press or keyboard focus survives a refresh.
    var key = off ? 'off|' + hasTags : JSON.stringify([hasTags, ids, vs.map(function (v) { return [v.id, vShort(v)]; }),
      old.map(function (v) { return [v.id, vShort(v)]; })]);
    if (row.__bgv3key === key && (off || qs('[data-bgv3-machine]', row))) return;
    row.__bgv3key = key;
    var focusId = document.activeElement && row.contains(document.activeElement) ? document.activeElement.getAttribute('data-bgv3-pick') : null;
    qsa('[data-bgv3-machine], [data-bgv3-machine-add], .bgv3-applied__sep', row).forEach(function (el) { el.remove(); });
    if (off) { row.hidden = !hasTags; return; }
    var frag = document.createDocumentFragment();
    vs.forEach(function (v) {
      var on = ids.indexOf(v.id) >= 0;
      var li = document.createElement('li');
      li.setAttribute('data-bgv3-machine', v.id);
      // No count on the pill (FE-09, Ricky: a "0" reads as a dead end). The toolbar's
      // "Showing N of M" carries the scoped number and the fit bar names the machine.
      li.innerHTML = '<button type="button" class="bgv3-chip" aria-pressed="' + on + '" data-bgv3-pick="' + esc(v.id) + '">' + (on ? ICON.check : '') +
        '<span class="visually-hidden">Show parts for </span>' + esc(vShort(v)) + '</button>';
      frag.appendChild(li);
    });
    old.forEach(function (v) {
      var li = document.createElement('li');
      li.setAttribute('data-bgv3-machine', v.id);
      li.innerHTML = pickBtn(v, 'bgv3-chip bgv3-chip--pick', vShort(v) + ': pick model');
      frag.appendChild(li);
    });
    if (vs.length + old.length < 5) {
      var add = document.createElement('li');
      add.setAttribute('data-bgv3-machine-add', '');
      add.innerHTML = '<button type="button" class="bgv3-chip" data-bge-action="open-drawer">' + ICON.plus + 'Add</button>';
      frag.appendChild(add);
    }
    if (hasTags) { var sep = document.createElement('li'); sep.className = 'bgv3-applied__sep'; sep.setAttribute('aria-hidden', 'true'); frag.appendChild(sep); }
    row.insertBefore(frag, row.firstChild);
    row.hidden = false;
    if (focusId) {
      var back = qsa('[data-bgv3-pick]', row).filter(function (b) { return b.getAttribute('data-bgv3-pick') === focusId; })[0];
      if (back) back.focus();
    }
  }
  // Chips drive the engine's own checkboxes (the sheet stays the multi-select truth).
  function pickMachine(id) {
    var boxes = qsa('[data-bge-gf-block] [data-bge-gf-v]');
    if (!boxes.length) return;
    var ids = gfSelectedIds();
    var only = ids.length === 1 && ids[0] === id;
    // Second tap on the only selected machine returns to every saved machine.
    boxes.forEach(function (b) { b.checked = only ? true : b.value === id; });
    var target = boxes.filter(function (b) { return b.value === id; })[0] || boxes[0];
    target.dispatchEvent(new Event('change', { bubbles: true }));
    track('bgv3_machine_chip', { action: only ? 'all' : 'only', machines: garage().length });
  }

  // Theme filter navigation (same flow as theme.js filterAjaxClick).
  function goConstraint(tags) {
    var Q = (window.Shopify && window.Shopify.queryParams) || {};
    delete Q.page;
    if (tags.length) Q.constraint = tags.join('+'); else delete Q.constraint;
    var qsParts = [];
    Object.keys(Q).forEach(function (k) { if (Q[k] != null && Q[k] !== '') qsParts.push(encodeURIComponent(k) + '=' + encodeURIComponent(Q[k]).replace(/%2B/g, '+')); });
    var url = window.location.pathname + (qsParts.length ? '?' + qsParts.join('&') : '');
    if (window.History && window.History.pushState && qs('.template-collection')) {
      window.History.pushState({ param: Q }, document.title, url);
    } else {
      window.location.href = url;
    }
  }
  function currentTags() {
    var c = new URLSearchParams(window.location.search).get('constraint');
    if (c) return c.split(/[+ ]/).filter(Boolean);
    return qsa('[data-bgv3-remove-tag]').map(function (a) { return a.getAttribute('data-bgv3-remove-tag'); });
  }

  // ---- 4. Filter sheet ------------------------------------------------------
  var sidebar = qs('.bgv3-plp > .page-sidebar');
  var openBtn = qs('[data-bgv3-filter-open]');
  var scrim = null, pending = null, lastFocus = null;
  function sheetMode() { return !DESK.matches; }
  function ensureSheetChrome() {
    if (!sidebar || qs('.sidebar-sheet__head', sidebar)) return;
    sidebar.id = sidebar.id || 'bgv3-sheet';
    sidebar.setAttribute('aria-label', 'Filters');
    var head = document.createElement('div');
    head.className = 'sidebar-sheet__head';
    head.innerHTML = '<h2 class="sidebar-sheet__title" id="bgv3-sheet-title">Filter</h2><button type="button" class="sidebar-sheet__close" data-bgv3-sheet-close aria-label="Close filters">' + ICON.x + '</button>';
    var foot = document.createElement('div');
    foot.className = 'sidebar-sheet__foot';
    foot.innerHTML = '<button type="button" class="sidebar-sheet__clear" data-bgv3-sheet-clear>Clear all</button><button type="button" class="bgv2-btn bgv2-btn--primary sidebar-sheet__apply" data-bgv3-sheet-apply>Show results</button>';
    sidebar.insertBefore(head, sidebar.firstChild);
    sidebar.appendChild(foot);
    scrim = document.createElement('div');
    scrim.className = 'bgv3-scrim';
    scrim.setAttribute('data-bgv3-sheet-close', '');
    scrim.hidden = true;
    document.body.appendChild(scrim);
  }
  function openSheet() {
    if (!sidebar) return;
    ensureSheetChrome();
    pending = currentTags().slice();
    lastFocus = document.activeElement;
    sidebar.classList.add('is-open');
    sidebar.setAttribute('role', 'dialog');
    sidebar.setAttribute('aria-modal', 'true');
    sidebar.setAttribute('aria-labelledby', 'bgv3-sheet-title');
    document.body.classList.add('bgv3-sheet-open');
    if (scrim) scrim.hidden = false;
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    syncPendingUI(); updateCounts(); updateApply();
    var close = qs('[data-bgv3-sheet-close]', sidebar);
    setTimeout(function () { (close || sidebar).focus(); }, 60);
  }
  function closeSheet(restore) {
    if (!sidebar || !sidebar.classList.contains('is-open')) return;
    sidebar.classList.remove('is-open');
    sidebar.removeAttribute('role'); sidebar.removeAttribute('aria-modal');
    document.body.classList.remove('bgv3-sheet-open');
    if (scrim) scrim.hidden = true;
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (restore !== false) { pending = null; syncPendingUI(); }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function syncPendingUI() {
    if (!sidebar) return;
    var set = pending || currentTags();
    qsa('.sidebarBlock_filter .list-tags li', sidebar).forEach(function (li) {
      var inp = qs('input', li); if (!inp) return;
      var on = set.indexOf(inp.value) >= 0;
      inp.checked = on;
      li.classList.toggle('is-pending', !!pending && on !== (currentTags().indexOf(inp.value) >= 0));
    });
  }
  // Batch apply on phones and tablets: a tick changes the pending set only (NN/g, Baymard).
  document.addEventListener('click', function (e) {
    if (!sidebar || !sheetMode() || !sidebar.classList.contains('is-open')) return;
    var hit = e.target.closest && e.target.closest('.sidebarBlock_filter .list-tags label, .sidebarBlock_filter .list-tags a, .sidebarBlock_filter .list-tags input, .sidebarBlock.show_clear .clear');
    if (!hit || !sidebar.contains(hit)) return;
    e.preventDefault(); e.stopPropagation();
    if (hit.classList.contains('clear')) {
      var blk = hit.closest('.sidebarBlock');
      qsa('input', blk).forEach(function (i) { var k = pending.indexOf(i.value); if (k >= 0) pending.splice(k, 1); });
    } else {
      var inp = qs('input', hit.closest('li'));
      if (!inp) return;
      var k = pending.indexOf(inp.value);
      if (k >= 0) pending.splice(k, 1); else pending.push(inp.value);
    }
    // A cancelled click on the input itself (Space) restores its old state after dispatch: sync after that.
    if (hit.tagName === 'INPUT') setTimeout(syncPendingUI, 0); else syncPendingUI();
    updateApply();
  }, true);
  // FL1-06: a Space on a filter checkbox clicks the input itself, which the theme's label handler
  // (theme.js ajaxFilterTags) never sees. Cancel the native toggle and click the label instead, so the
  // theme flow runs once; the open sheet's batch handler above already owns its own ticks. A keyboard
  // tick or Clear notes where focus was, and onSwap puts it back after the sidebar is swapped.
  var swapFocus = null;
  document.addEventListener('click', function (e) {
    if (!sidebar || !e.target.closest) return;
    var inp = e.target.closest('.sidebarBlock_filter .list-tags input[type="checkbox"]');
    var clr = !inp && e.detail === 0 && e.target.closest('.sidebarBlock.show_clear .clear');
    if (!(inp || clr) || !sidebar.contains(inp || clr)) return;
    if (sidebar.classList.contains('is-open') && sheetMode()) return;
    var blk = qs('.sidebarBlock-content', (inp || clr).closest('.sidebarBlock'));
    swapFocus = { value: inp ? inp.value : '', block: blk ? blk.id : '' };
    if (!inp) return;
    e.preventDefault(); e.stopPropagation();
    var lab = inp.nextElementSibling;
    if (lab && lab.tagName === 'LABEL') lab.click();
  }, true);
  function restoreSwapFocus() {
    var sf = swapFocus; swapFocus = null;
    // FL1-46: a removed chip (or Clear all) was inside the swapped #Collection. Focus the chip now in its slot,
    // else the one before it, else the results count above the grid ("Showing N parts", desktop) or the Filter
    // button (phones, where the count is hidden), never <body>.
    if (sf && sf.chip != null) {
      var chips = qsa('[data-bgv3-applied] [data-bgv3-remove-tag]').filter(function (c) { return c.offsetParent !== null; });
      var to = sf.chip >= 0 ? (chips[sf.chip] || chips[sf.chip - 1]) : null;
      if (!to) { var cnt = qs('[data-bgv3-count]'); if (cnt && cnt.offsetParent !== null) { cnt.setAttribute('tabindex', '-1'); to = cnt; } }
      if (!to) to = qs('[data-bgv3-filter-open]');
      if (to) to.focus();
      return;
    }
    if (!sf || !sidebar) return;
    var el = sf.value && qsa('.sidebarBlock_filter .list-tags input', sidebar).filter(function (i) { return i.value === sf.value && i.offsetParent !== null; })[0];
    if (!el && sf.block) el = qsa('.bgv2-filter-toggle', sidebar).filter(function (b) { return b.getAttribute('aria-controls') === sf.block; })[0];
    if (el) el.focus();
  }

  var applyTimer = null, applyRun = 0;
  function updateApply() {
    var btn = sidebar && qs('[data-bgv3-sheet-apply]', sidebar);
    if (!btn) return;
    var tags = pending || currentTags();
    clearTimeout(applyTimer);
    var run = ++applyRun;
    applyTimer = setTimeout(function () {
      index(tags.join('+')).then(function (rows) {
        if (run !== applyRun) return;
        var n = garageRows(rows).length;
        btn.textContent = 'Show ' + n + ' ' + plural(n, 'part');
        btn.disabled = n === 0;
      }, function () { btn.textContent = 'Show results'; btn.disabled = false; });
    }, 250);
  }
  function applySheet() {
    var tags = pending || currentTags();
    var changed = tags.join('+') !== currentTags().join('+');
    track('bgv3_filter_apply', { filters: tags.length, changed: changed });
    closeSheet(false);
    pending = null;
    if (changed) goConstraint(tags);
  }

  // N-A18: nothing to filter (gear: no group can narrow, no tag applied, no machine choice that narrows) hides the
  // Filter button; the sort takes the toolbar. The Garage block narrows when a machine is saved and not every part is
  // universal. Runs after the counts (narrowN) and on every refresh, since the fit result can land later.
  var narrowN = -1;
  function syncFilterBtn() {
    if (!openBtn || narrowN < 0) return;
    var gst = gfState(), gres = gst && gst.result;
    var gUni = gres && !gres.fits.length && gres.universal && gres.universal.length === gres.total;
    var gUseful = !!qs('[data-bge-gf-block]') && garage().length > 0 && !gUni;
    var hide = !narrowN && !currentTags().length && !gUseful;
    if (openBtn.hidden !== hide) openBtn.hidden = hide;
  }

  // Counts on every option: products in this view (and the Garage selection) that carry the tag.
  function updateCounts() {
    if (!sidebar || SCOPE === 'search') return;
    var tags = currentTags();
    index().then(function (rows) {
      var base = garageRows(rows);
      var counts = {};
      base.forEach(function (r) { rowTagHandles(r).forEach(function (h) { counts[h] = (counts[h] || 0) + 1; }); });
      // FL3-15: the server's tag gate only sees page one, so it also lists options the whole collection (or, over
      // the 1,000-tag cap, the theme's known lists) carries, marked data-bgv2-unverified. Keep one only if a part
      // in this view carries it; a block that drops options recounts its Show all button, and the promoted row
      // is rebuilt with the confirmed options. Runs once per sidebar render (no observer, CR-17).
      var unv = qsa('.sidebarBlock_filter li[data-bgv2-unverified]', sidebar);
      if (unv.length) {
        var inView = {};
        rows.forEach(function (r) { rowTagHandles(r).forEach(function (h) { inView[h] = true; }); });
        var touched = [];
        unv.forEach(function (li) {
          var inp = qs('input', li);
          if (inp && (inView[inp.value] || tags.indexOf(inp.value) >= 0)) { li.removeAttribute('data-bgv2-unverified'); return; }
          var blk = li.closest('.sidebarBlock_filter');
          if (touched.indexOf(blk) < 0) touched.push(blk);
          li.parentNode.removeChild(li);
        });
        touched.forEach(function (blk) {
          var content = qs('.sidebarBlock-content', blk), more = qs('[data-bgv2-filter-more]', blk);
          var n = qsa('.list-tags li', blk).length;
          if (!more) return;
          if (n <= 12) { content.classList.remove('is-long'); more.parentNode.removeChild(more); return; }
          var m = (more.getAttribute('data-more') || '').replace(/\d+/, String(n));
          more.setAttribute('data-more', m);
          if (more.getAttribute('aria-expanded') !== 'true') more.textContent = m;
        });
        initPromoted();
      }
      qsa('.sidebarBlock_filter .list-tags li', sidebar).forEach(function (li) {
        var inp = qs('input', li), lab = qs('label', li);
        if (!inp || !lab) return;
        var c = qs('.bgv3-count', lab);
        if (!c) { c = document.createElement('span'); c.className = 'bgv3-count'; lab.appendChild(c); }
        var n = counts[inp.value] || 0;
        c.innerHTML = tags.indexOf(inp.value) >= 0 ? '' : n + '<span class="visually-hidden"> ' + plural(n, 'part') + '</span>';
      });
      // F5-22: a group whose only option, unchecked, is every part in view ("ATV 646" on the ATV hub) cannot
      // narrow anything, so it is hidden instead of greeting the rider as the one open group.
      // N-A5: the same for a group of several options when none is ticked and every one holds all or none of the view
      // (dual-sport hub: Dirt Bike 62 / Dual-Sport 62 of 62; packing: both groups 5 of 5).
      qsa('.sidebarBlock_filter', sidebar).forEach(function (b) {
        var ins = qsa('.list-tags li input', b);
        var moot = ins.length > 0 && ins.every(function (inp) {
          var n = counts[inp.value] || 0;
          return tags.indexOf(inp.value) < 0 && (n === base.length || n === 0);
        });
        b.classList.toggle('is-moot', moot);
      });
      // FL2-24 (R5-08): with no group open (a class hub, whose one Vehicle Type option is moot), open the first group
      // that can narrow, once per sidebar render. It takes the state the server renders for an open group, so
      // Bootstrap's collapse and aria-expanded (FL1-06) stay in step. One pass after the counts, no observer (CR-17).
      var groups = qsa('.sidebarBlock_filter', sidebar).filter(function (b) { return !b.classList.contains('is-moot') && qs('.list-tags li', b); });
      var anyOpen = groups.some(function (b) { var c = qs('.sidebarBlock-content', b); return c && c.classList.contains('show'); });
      narrowN = groups.length;
      syncFilterBtn();
      if (groups.length && !anyOpen && !groups[0].hasAttribute('data-bgv2-lead')) {
        groups[0].setAttribute('data-bgv2-lead', '');
        var c0 = qs('.sidebarBlock-content', groups[0]), t0 = qs('.bgv2-filter-toggle', groups[0]);
        if (c0) c0.classList.add('show');
        if (t0) { t0.classList.remove('collapsed'); t0.setAttribute('aria-expanded', 'true'); }
      }
    }, function () { /* no index: no counts, page still works */ });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bgv3-filter-open], [data-bgv3-sheet-close], [data-bgv3-sheet-apply], [data-bgv3-sheet-clear], [data-bgv3-pick], [data-bgv3-remove-tag], [data-bgv3-clear], [data-bgv3-promo], .bgv3-ladder__tab, [data-bgv3-more-btn]');
    if (!t) return;
    if (t.hasAttribute('data-bgv3-filter-open')) { e.preventDefault(); if (sheetMode()) openSheet(); else { var f = qs('.sidebarBlock_filter', sidebar); if (f) f.scrollIntoView({ block: 'start' }); } }
    else if (t.hasAttribute('data-bgv3-sheet-close')) { e.preventDefault(); closeSheet(); }
    else if (t.hasAttribute('data-bgv3-sheet-apply')) { e.preventDefault(); applySheet(); }
    else if (t.hasAttribute('data-bgv3-sheet-clear')) { e.preventDefault(); pending = []; syncPendingUI(); updateApply(); }
    else if (t.hasAttribute('data-bgv3-pick')) { e.preventDefault(); pickMachine(t.getAttribute('data-bgv3-pick')); }
    else if (t.hasAttribute('data-bgv3-remove-tag')) {
      if (!qs('.template-collection')) return;
      e.preventDefault();
      var rm = t.getAttribute('data-bgv3-remove-tag');
      swapFocus = { chip: qsa('[data-bgv3-applied] [data-bgv3-remove-tag]').indexOf(t) };
      goConstraint(currentTags().filter(function (x) { return x !== rm; }));
    }
    else if (t.hasAttribute('data-bgv3-clear')) { if (!qs('.template-collection')) return; e.preventDefault(); swapFocus = { chip: -1 }; goConstraint([]); }
    else if (t.hasAttribute('data-bgv3-promo')) { e.preventDefault(); togglePromo(t); }
    else if (t.classList.contains('bgv3-ladder__tab')) { e.preventDefault(); selectTab(t, true); }
    else if (t.hasAttribute('data-bgv3-more-btn')) { e.preventDefault(); e.stopPropagation(); loadMore(t); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (!sidebar || !sidebar.classList.contains('is-open')) return;
    // FL4-05: keys inside the Garage dialog (opened from the sheet's finder) are the dialog's own; one Escape closes
    // only the dialog and focus goes back to the finder in the still-open sheet.
    if (e.target.closest && e.target.closest('[data-bge-drawer]')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var f = qsa('button, [href], input, select, [tabindex]:not([tabindex="-1"])', sidebar).filter(function (el) { return el.offsetParent !== null && !el.disabled; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  DESK.addEventListener && DESK.addEventListener('change', function () { if (DESK.matches) closeSheet(); });

  // ---- 5. Model groups: fitting years first, empty groups hidden ---------------
  function orderGroups() {
    var grid = qs('#Collection .halo-column-product[data-bgv3-grouped]');
    if (!grid) return;
    var vs = garage(), b = B();
    if (vs.length && b.parseTags && b.fitFeed) {
      qsa('.bgv3-group', grid).forEach(function (g) {
        var key = g.getAttribute('data-bgv3-group');
        var items = qsa('.halo-item[data-bgv3-in="' + key + '"]', grid);
        var rank = function (it) {
          var c = qs('[data-bge-tags]', it); if (!c) return 0;
          var s = b.fitFeed.best(b.parseTags(c.getAttribute('data-bge-tags') || ''), vs, c.getAttribute('data-bge-type') || '').state;
          return s === 'fits' ? 0 : s === 'universal' ? 1 : s === 'wrong_year' ? 2 : 3;
        };
        var sorted = items.map(function (it, i) { return { it: it, r: rank(it), i: i }; }).sort(function (a, c) { return a.r - c.r || a.i - c.i; });
        var anchor = g;
        sorted.forEach(function (o) { anchor.after(o.it); anchor = o.it; });
      });
    }
    syncGroups();
  }
  function syncGroups() {
    var grid = qs('#Collection .halo-column-product[data-bgv3-grouped]');
    if (!grid) return;
    qsa('.bgv3-group', grid).forEach(function (g) {
      var key = g.getAttribute('data-bgv3-group');
      var vis = qsa('.halo-item[data-bgv3-in="' + key + '"]', grid).filter(function (it) { return !it.hasAttribute('data-bge-gf-hidden') && !it.hasAttribute('data-bge-kf-hidden'); }).length;
      g.classList.toggle('is-empty', vis === 0);
      setText(qs('[data-bgv3-group-n]', g), String(vis));
    });
  }

  // ---- 6. Ladder: tabs, ?bgv2_series=, the rider's year -------------------------
  var ladder = qs('[data-bgv3-ladder]');
  function selectTab(tab, focus) {
    if (!ladder || !tab) return;
    qsa('.bgv3-ladder__tab', ladder).forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
    if (focus) tab.focus();
  }
  function yearIn(tag, y) {
    var m = /^(\d{2,4})-(\d{2,4})$/.exec(String(tag || '').trim());
    if (!m) return false;
    var f = function (s) { var n = parseInt(s, 10); return s.length === 2 ? (n >= 50 ? 1900 + n : 2000 + n) : n; };
    return y >= f(m[1]) && y <= f(m[2]);
  }
  function initLadder() {
    if (!ladder) return;
    ladder.addEventListener('keydown', function (e) {
      var tab = e.target.closest('.bgv3-ladder__tab'); if (!tab) return;
      var tabs = qsa('.bgv3-ladder__tab', ladder), i = tabs.indexOf(tab);
      if (e.key === 'ArrowRight') { e.preventDefault(); selectTab(tabs[(i + 1) % tabs.length], true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); selectTab(tabs[(i - 1 + tabs.length) % tabs.length], true); }
    });
    var m = /[?&]bgv2_series=([^&]+)/.exec(window.location.search);
    if (m) {
      var want = decodeURIComponent(m[1].replace(/\+/g, ' ')).toLowerCase().split(',').map(function (s) { return s.trim(); });
      var hit = null;
      want.some(function (w) { hit = qsa('.bgv3-step', ladder).filter(function (s) { return (s.getAttribute('data-series') || '').toLowerCase() === w; })[0]; return !!hit; });
      if (hit) {
        var panel = hit.closest('[role="tabpanel"]');
        var tab = panel && qs('#' + panel.getAttribute('aria-labelledby'));
        if (tab) selectTab(tab, false);
        hit.classList.add('is-current');
      }
    }
    ladderYear();
  }
  // With a saved machine of this model, each step links to the product for the rider's year.
  function ladderYear() {
    if (!ladder) return;
    var vs = garage(), st = gfState(), res = st && st.result;
    if (!vs.length) return;
    var v = vs[0];
    if (res && res.perVehicle) vs.forEach(function (x) { if ((res.perVehicle[x.id] || 0) > (res.perVehicle[v.id] || 0)) v = x; });
    var y = parseInt(v.year, 10); if (!y) return;
    qsa('.bgv3-step', ladder).forEach(function (s) {
      var opts = (s.getAttribute('data-bgv3-opts') || '').split('|').filter(Boolean).map(function (o) { var p = o.split('^'); return { url: p[0], years: p[1] }; });
      var mine = opts.filter(function (o) { return yearIn(o.years, y); })[0];
      if (mine) s.setAttribute('href', mine.url);
    });
  }

  // ---- 7. Load more (collections and search): append, count, keep page links for crawlers ----
  function loadMore(btn) {
    var url = btn.getAttribute('href');
    if (!url || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var label = btn.textContent;
    btn.textContent = 'Loading\u2026';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var grid = qs('#Collection .halo-column-product'), nGrid = qs('#Collection .halo-column-product', doc);
      if (!grid || !nGrid) throw new Error('no grid');
      var focusTo = null;
      qsa(':scope > .halo-item', nGrid).forEach(function (it, i) {
        var node = document.importNode(it, true);
        qsa('img[fetchpriority]', node).forEach(function (im) { im.removeAttribute('fetchpriority'); im.setAttribute('loading', 'lazy'); });
        grid.appendChild(node);
        if (i === 0) focusTo = qs('.bgv3-card__link', node);
      });
      var more = qs('[data-bgv3-more]'), nMore = qs('[data-bgv3-more]', doc);
      if (more && nMore) more.replaceWith(document.importNode(nMore, true));
      else if (more) more.remove();
      var shown = qsa('#Collection .halo-column-product > .halo-item').length;
      var c = qs('[data-bgv3-more-count]'); var total = totalInView();
      if (c) c.textContent = 'Showing ' + Math.min(shown, total) + ' of ' + total + (SCOPE === 'search' ? ' results' : ' parts');
      var bar = qs('[data-bgv3-more-bar]'); if (bar && total) bar.style.width = Math.round(100 * Math.min(shown, total) / total) + '%';
      if (focusTo) focusTo.focus({ preventScroll: true });
      // Most popular stays once per class and series across loaded pages too (FL4-08, FL5-02).
      if (B().popOnce) B().popOnce();
      if (B().renderBadges) B().renderBadges();
      track('bgv3_load_more', { surface: SCOPE, shown: shown, total: total });
    }).catch(function () { window.location.href = url; });
  }

  // ---- 8. Search: machine shortcut row --------------------------------------------
  function initSearchHit() {
    var served = qs('[data-bgv3-hit-server]');
    if (served && SCOPE === 'search') { track('bgv3_search_machine_row', { q: (new URLSearchParams(window.location.search).get('q') || '').toLowerCase(), collection: served.getAttribute('href').split('/').pop() }); return; }
    var slot = qs('[data-bgv3-machine-hit]');
    if (!slot || SCOPE !== 'search') return;
    var q = (new URLSearchParams(window.location.search).get('q') || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    if (!q) return;
    var cfg = window.BGV2 || {}, url = cfg.modelCollectionsUrl;
    if (!url) return;
    fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      var handles = d.handles || [];
      var words = ' ' + q + ' ', best = null;
      handles.forEach(function (h) {
        var parts = h.replace(/-exhaust$/, '').split('-');
        // Model words without the make must all be in the query ("raptor 700", "rzr xp 1000", "crf 450r").
        var model = parts.slice(parts[0] === 'can' ? 2 : 1);
        var joined = model.join(' ');
        var squashed = model.join('');
        var ok = words.indexOf(' ' + joined + ' ') >= 0 || words.replace(/ /g, '').indexOf(squashed) >= 0 && squashed.length >= 5;
        if (ok && (!best || joined.length > best.joined.length)) best = { h: h, joined: joined, make: parts[0] };
      });
      if (!best) return;
      var name = best.joined.replace(/\b([a-z])/g, function (c) { return c.toUpperCase(); }).replace(/\b(Xp|Rzr|Crf|Trx|Yfz|Kx|Klx|Klr|Yz|Wr|Rm|Lt|Kfx|Xr|Rs1|Ex|Ho)\b/gi, function (w) { return w.toUpperCase(); }).replace(/\b(\d+[a-z]+)\b/g, function (w) { return w.toUpperCase(); });
      var make = best.make.charAt(0).toUpperCase() + best.make.slice(1);
      var label = (slot.getAttribute('data-label') || 'Shop {model} parts').replace('{model}', make + ' ' + name);
      slot.outerHTML = '<a class="bgv3-machine-hit" href="/collections/' + esc(best.h) + '" data-bgv3-hit><span class="bgv3-fit__icon">' + ICON.garage + '</span><span><b>' + esc(label) + '</b><span class="bgv3-fit__note">' + esc(((window.BGV2 || {}).strings || {}).searchModelNote || 'Every part made for this machine, with the series ladder') + '</span></span><span class="bgv3-step__go">' + ICON.chev + '</span></a>';
      track('bgv3_search_machine_row', { q: q, collection: best.h });
    }).catch(function () { /* no row */ });
  }

  // ---- 9. Promoted filter row on part-type pages (Baymard: also stays in the sidebar) ----
  function initPromoted() {
    var slot = qs('[data-bgv3-promoted]');
    // The slot keeps its row's height from first paint on part pages (FL1-53); say when no row comes.
    if (!slot || SCOPE !== 'part' || !sidebar) { if (slot) slot.setAttribute('data-bgv3-none', ''); return; }
    var blocks = qsa('.sidebarBlock_filter', sidebar);
    var pick = null;
    ['Series', 'Product Type', 'Make', 'Vehicle Type'].some(function (title) {
      return blocks.some(function (b) {
        var h = qs('.sidebarBlock-heading', b); var lis = qsa('.list-tags li:not([data-bgv2-unverified])', b); // FL3-15: confirmed options only
        if (h && h.textContent.trim().toLowerCase().indexOf(title.toLowerCase()) >= 0 && lis.length >= 2 && lis.length <= 10) { pick = { title: title, lis: lis }; return true; }
        return false;
      });
    });
    if (!pick) { slot.hidden = true; slot.setAttribute('data-bgv3-none', ''); return; }
    var cur = currentTags();
    slot.innerHTML = '<nav class="bgv3-row" aria-label="Filter by ' + esc(pick.title) + '"><span class="bgv3-row__label">' + esc(pick.title) + '</span><ul class="bgv3-row__list">' +
      pick.lis.map(function (li) {
        var inp = qs('input', li), lab = qs('label', li); if (!inp || !lab) return '';
        var text = (lab.childNodes[0] && lab.childNodes[0].textContent || lab.textContent).trim();
        var on = cur.indexOf(inp.value) >= 0;
        return '<li><button type="button" class="bgv3-chip" aria-pressed="' + on + '" data-bgv3-promo="' + esc(inp.value) + '">' + (on ? ICON.check : '') + esc(text) + '</button></li>';
      }).join('') + '</ul></nav>';
    slot.hidden = false;
  }
  function togglePromo(btn) {
    var v = btn.getAttribute('data-bgv3-promo');
    var tags = currentTags();
    var k = tags.indexOf(v);
    if (k >= 0) tags.splice(k, 1); else tags.push(v);
    goConstraint(tags);
  }

  // ---- 10. Toolbar count, filter badge, sort label -------------------------------------
  function renderToolbar() {
    var c = qs('[data-bgv3-count]');
    var total = totalInView();
    var st = gfState(), res = st && st.result, ids = gfSelectedIds();
    if (c) {
      var shown = html.classList.contains('bge-gf-on') && res && ids.length ? res.fits.length + (res.universal ? res.universal.length : 0) : total;
      setHTML(c, shown !== total ? 'Showing <b>' + shown + ' of ' + total + '</b> ' + plural(total, 'part') : 'Showing <b>' + total + '</b> ' + plural(total, 'part'));
    }
    var n = qs('[data-bgv3-filter-n]');
    var uni = res && !res.fits.length && res.universal && res.universal.length === res.total;
    if (n) { var k = currentTags().length + (ids.length && !uni ? 1 : 0); setText(n, k ? String(k) : ''); }
    var sel = qs('#SortBy'), val = qs('[data-bgv3-sort-value]');
    var o = sel && sel.options[sel.selectedIndex], sv = qs('[data-bgv3-sort-short]');
    if (sel && val) setText(val, o ? o.text : '');
    if (sel && sv) setText(sv, o ? o.getAttribute('data-short') || o.text : '');
  }
  var sortSel = qs('#SortBy');
  if (sortSel) sortSel.addEventListener('change', renderToolbar);

  // ---- 11. FE-07: a machine saved, switched or given its model on this page ---------------
  // bge-garage.js has already cleared Show all and started the fit filter in place. Here:
  // the phone filter sheet closes (its pending tags apply, Ricky had to tap "Show 646 parts"
  // to see his 16), focus lands on the machine's chip once the count is in, the status line
  // announces it, and the results come back into view only if the shorter grid left the
  // rider looking at the footer. No reload, scroll otherwise kept.
  function settle(v, tries) {
    var st = gfState(), res = st && st.result;
    var banner = qs('[data-bge-gf-banner]');
    var busy = !res || !res.perVehicle || !(v.id in res.perVehicle) || (banner && !banner.hidden && banner.getAttribute('data-mode') === 'loading') ||
      html.classList.contains('bge-gf-pending');
    if (busy && tries < 60) { setTimeout(function () { settle(v, tries + 1); }, 100); return; }
    requestAnimationFrame(function () {
      if (document.body.classList.contains('bge-garage-open') || (sidebar && sidebar.classList.contains('is-open'))) return;
      var chip = qsa('[data-bgv3-pick]').filter(function (b) { return b.getAttribute('data-bgv3-pick') === v.id && b.offsetParent !== null; })[0];
      var target = chip || fit;
      if (target) {
        if (target === fit && !fit.hasAttribute('tabindex')) fit.setAttribute('tabindex', '-1');
        try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      }
      var grid = qs('#Collection');
      if (!grid) return;
      var r = grid.getBoundingClientRect();
      if (r.top < 0 && r.bottom < window.innerHeight * 0.5) {
        var top = parseInt(getComputedStyle(root).getPropertyValue('--bgv3-sticky-top'), 10) || 0;
        var head = fit && fit.offsetParent !== null ? fit : grid;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, window.pageYOffset + head.getBoundingClientRect().top - top - 12), behavior: reduce ? 'auto' : 'smooth' });
      }
    });
  }
  document.addEventListener('bge:garage', function (e) {
    var d = e.detail || {};
    if (!d.inPlace || !d.vehicle || ['save', 'switch', 'model'].indexOf(d.type) < 0 || SCOPE === 'search') return;
    if (sidebar && sidebar.classList.contains('is-open')) {
      if (pending && pending.join('+') !== currentTags().join('+')) applySheet(); else closeSheet();
    }
    track('bgv3_garage_pick', { type: d.type, scope: SCOPE });
    settle(d.vehicle, 0);
  });

  // ---- Wiring ------------------------------------------------------------------------
  var queued = false, plpObs = null;
  function refresh() {
    if (queued) return; queued = true;
    requestAnimationFrame(function () {
      queued = false;
      renderFit(); renderMachines(); syncGroups(); renderToolbar(); syncFilterBtn();
      // Drop the records our own writes just queued so they cannot schedule another frame.
      if (plpObs) plpObs.takeRecords();
    });
  }
  function onSwap() {
    // The theme swapped #Collection and the sidebar (filter or sort): re-read everything.
    sidebar = qs('.bgv3-plp > .page-sidebar');
    orderGroups(); updateCounts(); initPromoted(); refresh(); restoreSwapFocus();
  }
  function boot() {
    if (sidebar) sidebar.id = sidebar.id || 'bgv3-sheet';
    if (openBtn && sidebar) openBtn.setAttribute('aria-controls', sidebar.id);
    stickyTop();
    initLadder();
    initSearchHit();
    initPromoted();
    orderGroups();
    updateCounts();
    refresh();
    var banner = qs('[data-bge-gf-banner]');
    if (banner && window.MutationObserver) new MutationObserver(function () { refresh(); ladderYear(); }).observe(banner, { attributes: true, childList: true, subtree: true });
    var block = qs('[data-bge-gf-block]');
    var plp = qs('.bgv3-plp') || root;
    if (window.MutationObserver) {
      plpObs = new MutationObserver(function (muts) {
        // Our own writes (applied row, option counts) must not re-trigger a render.
        muts = muts.filter(function (m) { var t = m.target; return !(t.closest && (t.closest('[data-bgv3-applied]') || t.closest('.bgv3-count') || (m.type === 'childList' && Array.prototype.every.call(m.addedNodes, function (n) { return n.nodeType === 1 && n.classList && n.classList.contains('bgv3-count'); }) && m.addedNodes.length))); });
        if (!muts.length) return;
        var swapped = muts.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.id === 'Collection' || (n.classList && n.classList.contains('sidebar_content'))); }); });
        if (swapped) onSwap(); else refresh();
      });
      plpObs.observe(plp, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-bge-gf-hidden', 'checked'] });
    }
    if (block) block.addEventListener('change', function () { setTimeout(function () { updateCounts(); refresh(); }, 0); });
    var b = B();
    if (b.Garage && b.Garage.onChange) b.Garage.onChange(function () { setTimeout(function () { orderGroups(); updateCounts(); refresh(); ladderYear(); }, 0); });
  }
  // bge-garage.js is deferred like this file; wait until its API exists (it boots on DOMContentLoaded).
  function whenReady(fn, tries) {
    if (window.BGE && window.BGE.Garage) return fn();
    if ((tries || 0) > 60) return fn();
    setTimeout(function () { whenReady(fn, (tries || 0) + 1); }, 50);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { whenReady(boot); });
  else whenReady(boot);
})();
